
































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component
export default class AdminPasswordPanel extends Mixins(InputFieldMethods) {
    public currentPassword: string = '';
    public newPassword: string = '';
    public repeatPassword: string = '';

    constructor() {
        super();
    }

    get message() {
        let message = '';

        switch (this.responseCode) {
            case 422:
                message = this.$t('user.password-does-not-meet-requirements', 'The new password does not meet the requirements.');
                break;

            case 400:
                message = this.$t('user.incorrect-password', 'Incorrect password.');
                break;
        }

        return message;
    }

    get responseCode() {
        return this.$store.state.User.passwordChangeResponseCode;
    }

    public changePassword() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.CHANGE_PASSWORD, {
                    current: this.currentPassword,
                    new: this.newPassword,
                });
            }
        });
    }

    public destroyed() {
        this.$store.commit(Mutations.INITIALIZE_PASSWORD_CHANGE);
    }
}
